<template>
    <div class="form-group__wrapper">
        <label class="form-group__label" :class="{ disabled: isDisabled, isSmall: isSmallLabel }" :for="slug"
            >{{ label }}:

            <div v-if="description" class="form-group__tooltip">
                <IconTooltip :tooltipMessage="description" :isHtml="true"></IconTooltip>
            </div>
        </label>
        <div v-for="(filterItem, index) in filterValues" :key="index" class="checkbox-item">
            <input type="checkbox" class="form-group__check" :id="`${slug}_${index}`" :checked="filterItem.isSelected" :disabled="filterItem.isDisabled || isDisabled" @change="(e) => onCheckboxChange(index)" />
            <label :for="`${slug}_${index}`" class="form-group__item-label" :class="{ disabled: filterItem.isDisabled }"
                >{{ filterItem.title }} <span v-if="showNumResults"> ({{ filterItem.numResults }})</span></label
            >
        </div>
    </div>
</template>

<script lang="ts">
import IconTooltip from 'Vue/components/lockDesigner/components/shared/IconTooltip.vue';
export default {
    name: 'CheckboxGroup',
    components: {
        IconTooltip
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        hasInfoButton: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        showNumResults: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',
        }
    },
    methods: {
        onCheckboxChange(index) {
            let filterValuesCopy = [...this.filterValues];

            // Create a copy of options array

            // Toggle the isSelected property for the clicked checkbox
            filterValuesCopy[index].isSelected = !filterValuesCopy[index].isSelected;
            let newOptions = JSON.parse(JSON.stringify(filterValuesCopy));
            // Emit the updated options array

            this.$emit('filterChange', newOptions);
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
    },
};
</script>
